import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import { useLocation, useNavigate } from "react-router";
import styles from "../Styles/tables.module.css";
import { Url, getUser } from "../../Constants/globals";
import { TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX } from "react-icons/hi";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";

async function deleteUnitFunction(id){
  try {
    await axios.delete(`${Url}/units/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Unidade eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteUnitFunction(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a unidade"}</Alert>];
    }
  };
}

async function getUnits(page, search){
  try {
    const res = await axios
    .get(`${Url}/units?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getUnits(page, search);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Unidades({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [deleteUnit, setDeleteUnit] = useState("");
  const [alert, setAlert] = useState("");
  const searchRef = useRef(null);
  const [loadingData, setLoadingData] = useState(true);
  const [units, setUnits] = useState([]);
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [previousPage, setPreviousPage] = useState("");
  const [perPage, setPerPage] = useState(15);
  const [nextPage, setNextPage] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");
  const [total, setTotal] = useState(0);

  async function assignData() {
    const thisUnitsData = await getUnits(currentPage);
    setCurrentPage(thisUnitsData.current_page);
    setNextPage(thisUnitsData.next_page);
    setPreviousPage(thisUnitsData.prev_page);
    setPerPage(thisUnitsData.per_page);
    setUnits(thisUnitsData.items);
    setTotal(thisUnitsData.total_items);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newUnitsData = await getUnits(start ? start : nextPage, nomeSearch);
      setUnits(newUnitsData.items);
      setCurrentPage(newUnitsData.current_page);
      setNextPage(newUnitsData.next_page);
      setPreviousPage(newUnitsData.prev_page);
      setPerPage(newUnitsData.per_page);
      setTotal(newUnitsData.total_items);
    }
    else if (!next && previousPage) {
      const newUnitsData = await getUnits(previousPage, nomeSearch);
      setUnits(newUnitsData.items);
      setCurrentPage(newUnitsData.current_page);
      setNextPage(newUnitsData.next_page);
      setPreviousPage(newUnitsData.prev_page);
      setPerPage(newUnitsData.per_page);
      setTotal(newUnitsData.total_items);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = () => {
    if (showSearch){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchUnitsData = await getUnits(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchUnitsData.current_page);
    setNextPage(searchUnitsData.next_page);
    setPreviousPage(searchUnitsData.prev_page);
    setPerPage(searchUnitsData.per_page);
    setUnits(searchUnitsData.items);
    setTotal(searchUnitsData.total_items);
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteUnitFunction(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  return (
    <div className="body">
      {alert}
      {deleteUnit}
      <NavBar current={"unidades"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={styles.btnAdd} onClick={() => navigate("/unidades/adicionar")}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
          </div>
          <div className={styles.content}>
            {
              showSearch ?
              <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}  >
                <input 
                  className={styles.searchInput}
                  ref={searchRef}
                  onChange={(e) => setNomeSearch(e.target.value)}
                  placeholder="Procurar por nome"
                  value={nomeSearch}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                  <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                </div>
              </div>
            : ""
            }
            <div className={styles.table}>
              <div className={styles.unitsColumn}>
                <p>Nome</p>
                <p>Empresa</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
              {
                units?.length > 0 ?
                units.map((unit, index) =>
                  <div key={unit.id} className={styles.unitsInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                    <p title={unit.name ? unit.name : ""}>{unit.name ? unit.name : "-"}</p>
                    <p title={unit.company?.name ? unit.company.name : ""}>{unit.company?.name ? unit.company.name : "-"}</p>
                    <div className={styles.actions}>
                      <HiPencil onClick={() => navigate("/unidades/"+unit.id, {state: {page: currentPage}})} className={styles.icon} size={22}/>
                      <HiTrash className={styles.icon} onClick={() => setDeleteUnit(<DeleteModal close={setDeleteUnit} objectId={unit.id} objectName={unit.name} deleteFunction={getAlertDelete}/>)} size={22}/>
                    </div>
                  </div>
                )
                :
                <div className={styles.noData}>
                  <p>Não existem dados</p>
                </div>
              }
              </div>
              {
                previousPage || nextPage ?
                <div className={styles.arrows}>
                  <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                  <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                  {currentPage ? currentPage : ""}
                  <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                  <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
                </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Unidades;
